import LinkPanelButton, { ILinkPanelButton } from './LinkPanelButton';

export default LinkPanelButton;
export type { ILinkPanelButton };
